'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData$002dCertificate$002dOf$002dOrigin$0024$0024anon$00241 from "./app.data.-App-Document-Data-Certificate-Of-Origin$$anon$1.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataCertificateOfOrigin(number, issuer, recipient, originOfGoods, authority, documentaryCredit, placeOfReceipt, placeOfLoading, placeOfDelivery, placeOfDischarge, invoiceNumber, currency, goods, incoterm, shippingMarks, consignee, invoiceDate, purchaseOrderContract, hsCode, issueDate, shipper, manufacturer, vesselOrFlightNumber, voyage, preCarriageVesselOrFlightNumber, sealNumber, containerNumber, shipmentDate, truckNumber, documentNote) {
  this.ET = null;
  this.ES = null;
  this.EU = null;
  this.KN = null;
  this.Xy = null;
  this.KG = null;
  this.KR = null;
  this.KQ = null;
  this.KO = null;
  this.KP = null;
  this.KK = null;
  this.Bq = null;
  this.ti = null;
  this.KI = null;
  this.KX = null;
  this.KD = null;
  this.KJ = null;
  this.KT = null;
  this.KH = null;
  this.KL = null;
  this.KW = null;
  this.KM = null;
  this.KZ = null;
  this.L0 = null;
  this.KS = null;
  this.KU = null;
  this.KE = null;
  this.KV = null;
  this.KY = null;
  this.KF = null;
  this.ET = number;
  this.ES = issuer;
  this.EU = recipient;
  this.KN = originOfGoods;
  this.Xy = authority;
  this.KG = documentaryCredit;
  this.KR = placeOfReceipt;
  this.KQ = placeOfLoading;
  this.KO = placeOfDelivery;
  this.KP = placeOfDischarge;
  this.KK = invoiceNumber;
  this.Bq = currency;
  this.ti = goods;
  this.KI = incoterm;
  this.KX = shippingMarks;
  this.KD = consignee;
  this.KJ = invoiceDate;
  this.KT = purchaseOrderContract;
  this.KH = hsCode;
  this.KL = issueDate;
  this.KW = shipper;
  this.KM = manufacturer;
  this.KZ = vesselOrFlightNumber;
  this.L0 = voyage;
  this.KS = preCarriageVesselOrFlightNumber;
  this.KU = sealNumber;
  this.KE = containerNumber;
  this.KV = shipmentDate;
  this.KY = truckNumber;
  this.KF = documentNote;
}
export { $c_Lapp_data_AppDocumentDataCertificateOfOrigin as $c_Lapp_data_AppDocumentDataCertificateOfOrigin };
$p = $c_Lapp_data_AppDocumentDataCertificateOfOrigin.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentDataCertificateOfOrigin;
/** @constructor */
function $h_Lapp_data_AppDocumentDataCertificateOfOrigin() {
}
export { $h_Lapp_data_AppDocumentDataCertificateOfOrigin as $h_Lapp_data_AppDocumentDataCertificateOfOrigin };
$h_Lapp_data_AppDocumentDataCertificateOfOrigin.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentDataCertificateOfOrigin)) {
    if ((this.ET === x$0.ET)) {
      var x = this.ES;
      var x$2 = x$0.ES;
      var $x_25 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_25 = false;
    }
    if ($x_25) {
      var x$3 = this.EU;
      var x$4 = x$0.EU;
      var $x_24 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_24 = false;
    }
    if ((($x_24 && (this.KN === x$0.KN)) && (this.Xy === x$0.Xy))) {
      var x$5 = this.KG;
      var x$6 = x$0.KG;
      var $x_23 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_23 = false;
    }
    if ($x_23) {
      var x$7 = this.KR;
      var x$8 = x$0.KR;
      var $x_22 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_22 = false;
    }
    if ($x_22) {
      var x$9 = this.KQ;
      var x$10 = x$0.KQ;
      var $x_21 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_21 = false;
    }
    if ($x_21) {
      var x$11 = this.KO;
      var x$12 = x$0.KO;
      var $x_20 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_20 = false;
    }
    if ($x_20) {
      var x$13 = this.KP;
      var x$14 = x$0.KP;
      var $x_19 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_19 = false;
    }
    if (($x_19 && (this.KK === x$0.KK))) {
      var x$15 = this.Bq;
      var x$16 = x$0.Bq;
      var $x_18 = ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      var $x_18 = false;
    }
    if ($x_18) {
      var x$17 = this.ti;
      var x$18 = x$0.ti;
      var $x_17 = ((x$17 === null) ? (x$18 === null) : x$17.f(x$18));
    } else {
      var $x_17 = false;
    }
    if ($x_17) {
      var x$19 = this.KI;
      var x$20 = x$0.KI;
      var $x_16 = ((x$19 === null) ? (x$20 === null) : x$19.f(x$20));
    } else {
      var $x_16 = false;
    }
    if ($x_16) {
      var x$21 = this.KX;
      var x$22 = x$0.KX;
      var $x_15 = ((x$21 === null) ? (x$22 === null) : x$21.f(x$22));
    } else {
      var $x_15 = false;
    }
    if ($x_15) {
      var x$23 = this.KD;
      var x$24 = x$0.KD;
      var $x_14 = ((x$23 === null) ? (x$24 === null) : x$23.f(x$24));
    } else {
      var $x_14 = false;
    }
    if ($x_14) {
      var x$25 = this.KJ;
      var x$26 = x$0.KJ;
      var $x_13 = ((x$25 === null) ? (x$26 === null) : x$25.f(x$26));
    } else {
      var $x_13 = false;
    }
    if ($x_13) {
      var x$27 = this.KT;
      var x$28 = x$0.KT;
      var $x_12 = ((x$27 === null) ? (x$28 === null) : x$27.f(x$28));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$29 = this.KH;
      var x$30 = x$0.KH;
      var $x_11 = ((x$29 === null) ? (x$30 === null) : x$29.f(x$30));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$31 = this.KL;
      var x$32 = x$0.KL;
      var $x_10 = ((x$31 === null) ? (x$32 === null) : x$31.f(x$32));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$33 = this.KW;
      var x$34 = x$0.KW;
      var $x_9 = ((x$33 === null) ? (x$34 === null) : x$33.f(x$34));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$35 = this.KM;
      var x$36 = x$0.KM;
      var $x_8 = ((x$35 === null) ? (x$36 === null) : x$35.f(x$36));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$37 = this.KZ;
      var x$38 = x$0.KZ;
      var $x_7 = ((x$37 === null) ? (x$38 === null) : x$37.f(x$38));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$39 = this.L0;
      var x$40 = x$0.L0;
      var $x_6 = ((x$39 === null) ? (x$40 === null) : x$39.f(x$40));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$41 = this.KS;
      var x$42 = x$0.KS;
      var $x_5 = ((x$41 === null) ? (x$42 === null) : x$41.f(x$42));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$43 = this.KU;
      var x$44 = x$0.KU;
      var $x_4 = ((x$43 === null) ? (x$44 === null) : x$43.f(x$44));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$45 = this.KE;
      var x$46 = x$0.KE;
      var $x_3 = ((x$45 === null) ? (x$46 === null) : x$45.f(x$46));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$47 = this.KV;
      var x$48 = x$0.KV;
      var $x_2 = ((x$47 === null) ? (x$48 === null) : x$47.f(x$48));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$49 = this.KY;
      var x$50 = x$0.KY;
      var $x_1 = ((x$49 === null) ? (x$50 === null) : x$49.f(x$50));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$51 = this.KF;
      var x$52 = x$0.KF;
      return ((x$51 === null) ? (x$52 === null) : x$51.f(x$52));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 30;
});
$p.t = (function() {
  return "AppDocumentDataCertificateOfOrigin";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.ET;
      break;
    }
    case 1: {
      return this.ES;
      break;
    }
    case 2: {
      return this.EU;
      break;
    }
    case 3: {
      return this.KN;
      break;
    }
    case 4: {
      return this.Xy;
      break;
    }
    case 5: {
      return this.KG;
      break;
    }
    case 6: {
      return this.KR;
      break;
    }
    case 7: {
      return this.KQ;
      break;
    }
    case 8: {
      return this.KO;
      break;
    }
    case 9: {
      return this.KP;
      break;
    }
    case 10: {
      return this.KK;
      break;
    }
    case 11: {
      return this.Bq;
      break;
    }
    case 12: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyVector(this.ti);
      break;
    }
    case 13: {
      return this.KI;
      break;
    }
    case 14: {
      return this.KX;
      break;
    }
    case 15: {
      return this.KD;
      break;
    }
    case 16: {
      return this.KJ;
      break;
    }
    case 17: {
      return this.KT;
      break;
    }
    case 18: {
      return this.KH;
      break;
    }
    case 19: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(this.KL);
      break;
    }
    case 20: {
      return this.KW;
      break;
    }
    case 21: {
      return this.KM;
      break;
    }
    case 22: {
      return this.KZ;
      break;
    }
    case 23: {
      return this.L0;
      break;
    }
    case 24: {
      return this.KS;
      break;
    }
    case 25: {
      return this.KU;
      break;
    }
    case 26: {
      return this.KE;
      break;
    }
    case 27: {
      return this.KV;
      break;
    }
    case 28: {
      return this.KY;
      break;
    }
    case 29: {
      return this.KF;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "number";
      break;
    }
    case 1: {
      return "issuer";
      break;
    }
    case 2: {
      return "recipient";
      break;
    }
    case 3: {
      return "originOfGoods";
      break;
    }
    case 4: {
      return "authority";
      break;
    }
    case 5: {
      return "documentaryCredit";
      break;
    }
    case 6: {
      return "placeOfReceipt";
      break;
    }
    case 7: {
      return "placeOfLoading";
      break;
    }
    case 8: {
      return "placeOfDelivery";
      break;
    }
    case 9: {
      return "placeOfDischarge";
      break;
    }
    case 10: {
      return "invoiceNumber";
      break;
    }
    case 11: {
      return "currency";
      break;
    }
    case 12: {
      return "goods";
      break;
    }
    case 13: {
      return "incoterm";
      break;
    }
    case 14: {
      return "shippingMarks";
      break;
    }
    case 15: {
      return "consignee";
      break;
    }
    case 16: {
      return "invoiceDate";
      break;
    }
    case 17: {
      return "purchaseOrderContract";
      break;
    }
    case 18: {
      return "hsCode";
      break;
    }
    case 19: {
      return "issueDate";
      break;
    }
    case 20: {
      return "shipper";
      break;
    }
    case 21: {
      return "manufacturer";
      break;
    }
    case 22: {
      return "vesselOrFlightNumber";
      break;
    }
    case 23: {
      return "voyage";
      break;
    }
    case 24: {
      return "preCarriageVesselOrFlightNumber";
      break;
    }
    case 25: {
      return "sealNumber";
      break;
    }
    case 26: {
      return "containerNumber";
      break;
    }
    case 27: {
      return "shipmentDate";
      break;
    }
    case 28: {
      return "truckNumber";
      break;
    }
    case 29: {
      return "documentNote";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.yy = (function() {
  return this.ET;
});
$p.Wh = (function() {
  return this.ES;
});
$p.bXK = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector0$();
  return new $j_app$002edata$002e$002dApp$002dDocument$002dData$002dCertificate$002dOf$002dOrigin$0024$0024anon$00241.$c_Lapp_data_AppDocumentDataCertificateOfOrigin$$anon$1().bwL(this);
});
function $isArrayOf_Lapp_data_AppDocumentDataCertificateOfOrigin(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iM)));
}
export { $isArrayOf_Lapp_data_AppDocumentDataCertificateOfOrigin as $isArrayOf_Lapp_data_AppDocumentDataCertificateOfOrigin };
var $d_Lapp_data_AppDocumentDataCertificateOfOrigin = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataCertificateOfOrigin, "app.data.AppDocumentDataCertificateOfOrigin", ({
  iM: 1,
  ce: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppDocumentDataCertificateOfOrigin as $d_Lapp_data_AppDocumentDataCertificateOfOrigin };
//# sourceMappingURL=app.data.-App-Document-Data-Certificate-Of-Origin.js.map
